<script lang="ts" setup>
    import { computed, ref, watch } from 'vue'
    import { useCommonStore } from '@/stores/common'
    import dayjs from 'dayjs'
    import elementPlusZhCn from 'element-plus/es/locale/lang/zh-cn'
    import elementPlusEn from 'element-plus/es/locale/lang/en'
    import 'dayjs/locale/zh-cn'
    import 'dayjs/locale/en'

    const pageGlobalIsLoading = computed(() => {
        const commonStore = useCommonStore()
        return commonStore.pageGlobalIsLoading
    })

    const locale = computed(() => {
        const commonStore = useCommonStore()
        return commonStore.locale
    })
    dayjs.locale(locale.value)

    const currentLocale = ref(elementPlusZhCn)

    watch(
        () => locale.value,
        newValue => {
            dayjs.locale(newValue === 'zh-cn' ? 'zh-cn' : 'en')
            currentLocale.value = newValue === 'zh-cn' ? elementPlusZhCn : elementPlusEn
        },
    )
</script>

<template>
    <el-config-provider :locale="currentLocale">
        <div v-loading.fullscreen.lock="pageGlobalIsLoading"></div>
        <router-view />
    </el-config-provider>
</template>

<style lang="scss" scoped>
    html[data-theme='dark'] {
        .page-global-loading {
            background-color: #2c344a;

            .page-global-loading-title {
                color: rgb(255 255 255 / 85%);
            }
        }
    }

    .page-global-loading {
        display: flex;
        width: 100%;
        height: 100%;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        background-color: white;
    }

    .page-global-loading .page-global-loading-wrap {
        position: absolute;
        top: 50%;
        left: 50%;
        display: flex;
        transform: translate3d(-50%, -50%, 0);
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }

    .page-global-loading .page-global-loading-title {
        display: flex;
        font-size: 30px;
        color: rgb(0 0 0 / 85%);
        justify-content: center;
        align-items: center;
    }

    .page-global-loading .page-global-loading-logo {
        display: block;
        width: 70px;
        margin: 0;
    }
</style>
